import { useEffect, useState } from 'react';
import moment from 'moment/min/moment-with-locales';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { createRoot } from 'react-dom/client';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import store from './redux/store';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import useExTheme from './theme';

import App from './App';
import InitApp from './InitApp';

import ModalTable from './components/modal/ModalTable';
import Dashboard from './dashboard/Dashboard';
import ExternalForm from './externalForm/ExternalForm';
import { updateFavicon } from './helpers';

moment.locale('fr');

const domNode = document.getElementById('root');
const root = createRoot(domNode as HTMLElement);

const AppContainer = ({ external }: { external?: string }) => {
  const theme = useExTheme();

  return (
    <ChakraProvider theme={theme}>
      <DndProvider backend={HTML5Backend}>
        <InitApp />
        {external ? <ExternalForm hash={external} /> : <App />}
        <ModalTable />
      </DndProvider>
    </ChakraProvider>
  );
};

const Root = () => {
  const [company, setCompany] = useState<any>(null);
  const [hash, setHash] = useState<any>(null);

  useEffect(() => {
    const currCompany = localStorage.getItem('company') || '';
    let urlCompany: string;
    let isForm = false;
    let urlHash = '';

    if (/evisioncrm|localhost/.test(window.location.hostname)) {
      const splittedUrl = window.location.pathname.split('/');
      urlCompany = splittedUrl[1];
      isForm = splittedUrl[2] === 'form';
      urlHash = splittedUrl[3];
    } else {
      const urls = window.location.hostname.split('.');
      urlCompany = urls[urls.length - 2];

      updateFavicon(urlCompany);
    }

    if (isForm) {
      setHash(urlHash);
    }

    const isForceLogin = urlCompany === 'forceLogin';
    const hasCompany = currCompany && currCompany !== 'forceLogin';

    if (isForceLogin && hasCompany) {
      urlCompany && localStorage.setItem('company', currCompany);
      window.location.href = currCompany;
    } else {
      setCompany(urlCompany);
      urlCompany && localStorage.setItem('company', urlCompany);
    }
  }, []);

  return hash || company ? (
    <Provider store={store}>
      <AppContainer external={hash} />
    </Provider>
  ) : company === null ? null : (
    <Box overflow='auto'>
      <Dashboard />
    </Box>
  );
};

root.render(<Root />);
